<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-title">客户信息</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">住户名称：</span>
          </div>
          <el-input v-model="formData.enterpriseName" size="small" style="width: 220px" />
        </div>
        <div>
          <div class="textBox">
            <!--<b class="red">*</b>-->
            <span class="line-text">行业分类：</span>
          </div>
          <el-input v-model="formData.industry" size="small" style="width: 220px" />
        </div>
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">联系人1姓名：</span>
          </div>
          <el-input v-model="formData.oneContactPersonName" size="small" style="width: 220px" />
        </div>
      </div>

      <div class="form-line">
        <div>
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">联系人1手机：</span>
          </div>
          <el-input v-model="formData.oneContactPersonPhone" size="small" style="width: 220px" />
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">联系人2姓名：</span>
          </div>
          <el-input v-model="formData.secContactPersonName" size="small" style="width: 220px" />
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">联系人2手机：</span>
          </div>
          <el-input v-model="formData.secContactPersonPhone" size="small" style="width: 220px" />
        </div>
      </div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <span class="line-text">来访途径：</span>
          </div>
          <el-select v-model="formData.visiteWay" placeholder="请选择" size="mini" style="width: 220px">
            <el-option
              v-for="item in visiteWayList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>

      <!--<div class="form-title">推荐人信息</div>-->
      <!--<div class="form-line">-->
        <!--<div>-->
          <!--<div class="textBox">-->
            <!--<span class="line-text">推荐人姓名：</span>-->
          <!--</div>-->
          <!--<el-select v-model="recommendPersonCode" placeholder="请选择" size="mini" style="width: 220px">-->
            <!--<el-option-->
              <!--v-for="item in personList"-->
              <!--:key="item.code"-->
              <!--:label="item.name"-->
              <!--:value="item.code">-->
            <!--</el-option>-->
          <!--</el-select>-->
        <!--</div>-->
        <!--<div>-->
          <!--<div class="textBox">-->
            <!--<span class="line-text">推荐人手机：</span>-->
          <!--</div>-->
          <!--<el-input v-model="recommendPersonPhone" size="small" style="width: 220px" disabled />-->
        <!--</div>-->
      <!--</div>-->

      <div class="form-title">客户意向</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <span class="line-text">意向房源：</span>
          </div>
          <el-select v-model="intendRoomArr" multiple placeholder="请选择" size="mini" style="width: 220px">
            <el-option
              v-for="item in vacancyRoomList"
              :key="item.label"
              :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">意向面积：</span>
          </div>
          <el-input v-model="formData.intendArea" size="small" style="width: 220px" />
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">客户意向分类：</span>
          </div>
          <el-select v-model="formData.customIntendType" placeholder="请选择" size="mini" style="width: 220px">
            <el-option
              v-for="item in customIntendTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="form-title">预定信息</div>
      <div class="form-line">
        <div style="display: flex;justify-content: flex-start">
          <div class="textBox">
            <span class="line-text">是否预定：</span>
          </div>
          <div style="width: 220px;line-height: 32px;">
            <el-switch
              v-model="isReserve"
              active-text="已预定"
              inactive-text="未预定">
            </el-switch>
          </div>
        </div>
        <div>
          <div class="textBox">
            <span class="line-text">预定金：</span>
          </div>
          <el-input v-model="formData.roomDeposit" type="number" size="small" style="width: 220px" v-on:blur="roomDepositChange()" />
        </div>
      </div>

      <div class="form-title">其他</div>
      <div class="form-line">
        <div>
          <div class="textBox">
            <span class="line-text">跟进人：</span>
          </div>
          <el-select v-model="formData.fellowPeopleCode" filterable remote reserve-keyword :remote-method="remoteMethod" placeholder="请输入关键字搜索" size="mini" style="width: 220px">
            <el-option
              v-for="item in yqPersonList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-confirm-next @confirm="confirmNext" value="添加下一项" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/agent";
import { nError, nSuccess } from "../../../utils/notice";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";

export default {
  components: {
    ButtonConfirmNext,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "custom-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧合约",
          name: "custom-management"
        },
        {
          value: "客户管理"
        }
      ],
      mainTitle: "添加客户",
      subheading: "添加客户信息",
      visiteWayList: [
        {
          label: "电话",
          value: "0"
        },
        {
          label: "上门",
          value: "1"
        },
        {
          label: "小程序推荐",
          value: "2"
        },
        {
          label: "住户推荐",
          value: "3"
        }
      ],
      customIntendTypeList: [
        {
          label: "未分类",
          value: "0"
        },
        {
          label: "潜在客户",
          value: "1"
        },
        {
          label: "意向客户",
          value: "2"
        },
        {
          label: "成交客户",
          value: "3"
        },
        {
          label: "流失客户",
          value: "4"
        }
      ],
      vacancyRoomList: [],
      intendRoomArr: [],
      personList: [],
      yqPersonList: [],
      recommendPersonName: "",
      recommendPersonCode: "",
      recommendPersonPhone: "",
      isReserve: false,
      formData: {
        enterpriseName: "", // 住户名称
        industry: "", // 行业分类
        oneContactPersonName: "", // 联系人1姓名
        oneContactPersonPhone: "", // 联系人1手机
        secContactPersonName: "", // 联系人2姓名
        secContactPersonPhone: "", // 联系人2手机
        visiteWay: "", // 来访途径
        intendRoomCode: "", // 意向房源Code
        intendRoom: "", // 意向房源
        intendArea: "", // 意向面积
        customIntendType: "", // 客户分类
        fellowPeopleCode: "",
        fellowPeopleName: "",
        orderOrNot: "",
        roomDeposit: ""
      }
    };
  },
  created() {
    // this.getPersonList()
    this.getVacancyRoomInfo();
    this.remoteMethod();
    // this.getYqPersonList();
  },
  methods: {
    toCustomManagement() {
      this.$router.push({
        name: "custom-management"
      });
    },

    remoteMethod(query) {
      this.getYqPersonList(query);
    },

    // 获取跟进人列表
    getYqPersonList(searchKey) {
      this.$axios
        .post(api.getYqPersonList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.yqPersonList = data;
          }
        })
        .catch(errorHandler("获取跟进人列表失败"));
    },
    getPersonList() {
      this.$axios
        .post(api.getPersonList, {
          searchKey: ""
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.personList = data;
          }
        })
        .catch(errorHandler("查询人员列表失败"));
    },
    getVacancyRoomInfo() {
      this.$axios
        .post(api.getVacancyRoomInfo, {
          searchKey: ""
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map(v => {
              v.label = `${v.buildingName}${v.roomNumber}/${v.roomArea}m²`;
              v.value = v.code;
            });
            this.vacancyRoomList = data;
          }
        })
        .catch(errorHandler("查询空置房源失败"));
    },

    roomDepositChange() {
      if (this.formData.roomDeposit) {
        this.formData.roomDeposit = parseFloat(
          this.formData.roomDeposit
        ).toFixed(2);
      } else {
        this.formData.roomDeposit = "0.00";
      }
    },

    confirm() {
      if (!this.formData.enterpriseName) {
        nError("请输入住户名称");
        return false;
      }
      // if (!this.formData.industry) {
      //   nError('请选择行业分类')
      //   return false
      // }
      if (!this.formData.oneContactPersonName) {
        nError("请输入联系人1姓名");
        return false;
      }
      if (!this.formData.oneContactPersonPhone) {
        nError("请输入联系人1手机");
        return false;
      }
      if (this.formData.fellowPeopleCode) {
        this.yqPersonList.map(v => {
          if (v.code === this.formData.fellowPeopleCode) {
            this.formData.fellowPeopleName = v.name;
          }
        });
      }
      // this.formData.recommendPersonCode = this.recommendPersonCode
      // this.formData.recommendPersonName = this.recommendPersonName
      // this.formData.recommendPersonPhone = this.recommendPersonPhone
      this.formData.intendRoom = this.intendRoomArr.join(",");
      let intendRoomCodeArr = [];
      this.intendRoomArr.map(v => {
        this.intendRoomArr.map(val => {
          if (v === val.label) {
            intendRoomCodeArr.push(val.value);
          }
        });
      });
      this.formData.intendRoomCode = intendRoomCodeArr.join(",");

      if (!this.isReserve) {
        this.formData.orderOrNot = "1";
      } else {
        this.formData.orderOrNot = "0";
      }
      this.$axios
        .post(api.addCustom, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.toCustomManagement();
          }
        })
        .catch(errorHandler("添加失败"));
    },
    confirmNext() {
      if (!this.formData.enterpriseName) {
        nError("请输入住户名称");
        return false;
      }
      // if (!this.formData.industry) {
      //   nError('请选择行业分类')
      //   return false
      // }
      if (!this.formData.oneContactPersonName) {
        nError("请输入联系人1姓名");
        return false;
      }
      if (!this.formData.oneContactPersonPhone) {
        nError("请输入联系人1手机");
        return false;
      }
      // this.formData.recommendPersonCode = this.recommendPersonCode
      // this.formData.recommendPersonName = this.recommendPersonName
      // this.formData.recommendPersonPhone = this.recommendPersonPhone
      this.formData.intendRoom = this.intendRoomArr.join(",");

      let intendRoomCodeArr = [];
      this.intendRoomArr.map(v => {
        this.intendRoomArr.map(val => {
          if (v === val.label) {
            intendRoomCodeArr.push(val.value);
          }
        });
      });
      this.formData.intendRoomCode = intendRoomCodeArr.join(",");

      if (!this.isReserve) {
        this.formData.orderOrNot = "1";
      } else {
        this.formData.orderOrNot = "0";
      }

      this.$axios
        .post(api.addCustom, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            this.formData = {
              enterpriseName: "", // 住户名称
              industry: "", // 行业分类
              oneContactPersonName: "", // 联系人1姓名
              oneContactPersonPhone: "", // 联系人1手机
              secContactPersonName: "", // 联系人2姓名
              secContactPersonPhone: "", // 联系人2手机
              visiteWay: "", // 来访途径
              intendRoom: "", // 意向房源
              intendArea: "", // 意向面积
              customIntendType: "" // 客户分类
            };
            nSuccess("添加成功");
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.toCustomManagement();
    }
  },
  watch: {
    recommendPersonCode(val) {
      this.personList.map(v => {
        if (v.code === val) {
          this.recommendPersonName = v.name;
          this.recommendPersonPhone = v.phone;
        }
      });
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
  vertical-align: -webkit-baseline-middle;
}
.form-title {
  color: #333333;
  font-size: 16px;
  line-height: 28px;
  padding-left: 5px;
  border-left: 3px solid #00a0e6;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
}
.form-line > div {
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 122px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin: 40px auto;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less">
.el-input--mini .el-input__inner {
  height: 32px;
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/view/Agent/CustomManagement/CustomAdd.vue